import { render, staticRenderFns } from "./SideLegend.vue?vue&type=template&id=7f0b8afa"
import script from "./SideLegend.vue?vue&type=script&lang=js"
export * from "./SideLegend.vue?vue&type=script&lang=js"
import style0 from "./SideLegend.vue?vue&type=style&index=0&id=7f0b8afa&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports